import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Archivo } from '../models/Archivo';

@Injectable({
  providedIn: 'root'
})
export class ArchivosService {

  constructor(protected http: HttpClient, @Inject('BASE_URL') protected baseUrl: string) { }

  getArchivos(entityId: any, entityType: any): Observable<Archivo[]> {
    let params = new HttpParams()
      .set('entityId', entityId)
      .set('entityType', entityType)
    return this.http.get<Archivo[]>(this.baseUrl + 'api/File/GetFicherosList', { params });
  }

  deleteArchivo(entityId: any, id: any) {
    let params = new HttpParams()
      .set('entityId', entityId)
      .set('id', id)
    const url = this.baseUrl + 'api/File/fileDelete';
    return this.http.delete(url, { params });
  }

}
